import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturedClusterPipe } from './featured-cluster.pipe';


@NgModule({
  declarations: [
    FeaturedClusterPipe,
  ],
  exports: [
    FeaturedClusterPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class FeaturedClusterModule { }
